import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Alert, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { ReactElementLike } from 'prop-types';

const AlertDialogTitle = ({ children }: { children: ReactElementLike }) => {
  return <DialogTitle sx={{ m: 0, p: 2 }}>{children}</DialogTitle>;
};

type AlertDialogProps = {
  open: boolean;
  severity: AlertColor;
  title: string;
  message: string;
  onClose: () => void;
};

const AlertDialog = ({
  open,
  severity,
  title,
  message,
  onClose,
}: AlertDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <AlertDialogTitle>
        <Alert severity={severity}>
          <AlertTitle>{title}</AlertTitle>
        </Alert>
      </AlertDialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
